import React from "react";
import "../../../pages/comingSoon/comingSoon.css"; 

const StoreSkeleton = () => {
  return (
      <div className="main-page">
        <div className="skeleton skeleton-img"></div>

        <div className="skeleton skeleton-text mt-5" style={{ width: "280px", height: "34px" }}></div>

        <div className="skeleton skeleton-text mt-3" style={{ width: "340px", height: "20px" }}></div>
        <div className="skeleton skeleton-text mt-2" style={{ width: "300px", height: "20px" }}></div>
      </div>
  );
};

export default StoreSkeleton;
